import { render } from "./chat-dialog.vue?vue&type=template&id=39820e29&scoped=true"
import script from "./chat-dialog.vue?vue&type=script&lang=js"
export * from "./chat-dialog.vue?vue&type=script&lang=js"

import "./chat-dialog.vue?vue&type=style&index=0&id=39820e29&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39820e29"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress,QBtn});qInstall(script, 'directives', {ClosePopup});
